<template>
  <modal
    name="reference-form-modal"
    width="90%"
    height="auto"
    :scrollable="true"
    style="z-index: 9999"
    @closed="hideModal()"
  >
    <div class="p-5 field-of-fields">
      <h3 v-if="isAdd">Add Reference</h3>
      <h3 v-if="!isAdd">Edit Reference - {{ reference.name }}</h3>
      <hr style="margin-bottom: 0" />
      <FormGroupColumnLayout
        :submitClicked="submitClicked"
        :modelData="reference"
        :listFields="$store.getters.referenceListFields"
        :itemPerColumns="[6, 3]"
      />
      <hr />
      <div>
        <button class="mylisting-button secondary-button" @click="hideModal()">
          Cancel
        </button>
        <button
          v-if="!isAdd"
          class="mylisting-button danger-button"
          @click="showDeleteReferenceConfirmDialog()"
          style=""
        >
          Delete
        </button>
        <button
          class="mylisting-button dark-button"
          @click="handleClickSaveButton()"
          style="float: right"
        >
          Save
        </button>
      </div>
    </div>
  </modal>
</template>
<script>
import axios from "axios";
import FormGroupColumnLayout from "../../common/FormGroupColumnLayout";
import { FORM_TYPE, ACTION_TYPE } from "../../../constants/custom-define-type";

export default {
  name: "ReferenceFormDialog",
  components: {
    FormGroupColumnLayout
  },
  props: {
    user: Object,
    reference: Object,
    value: Boolean,
    isAdd: Boolean,
    isSendRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitClicked: false,
      ACTION_TYPE: ACTION_TYPE
    };
  },
  methods: {
    hideModal() {
      this.$modal.hide("reference-form-modal");
      this.$emit("input", false);
    },
    showModal() {
      console.log("show");
      this.$modal.show("reference-form-modal");
    },
    handleClickSaveButton() {
      this.submitClicked = true;
      if (
        this.hasInvalidField(
          this.reference,
          this.$store.getters.referenceListFields
        )
      ) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        if (this.isSendRequest) {
          if (this.isAdd) {
            this.postReference();
          } else {
            this.patchReference();
          }
        } else {
          this.hideModal();
          this.$emit(
            "saved",
            this.isAdd ? ACTION_TYPE.ADD : ACTION_TYPE.UPDATE
          );
        }
      }
    },
    postReference() {
      axios
        .post("/api/references/", {
          ...this.reference,
          user: this.user.id
        })
        .then(res => {
          this.hideModal();
          this.$emit("saved");
        })
        .catch(error => {
          console.log(error);
        });
    },
    patchReference() {
      const splitRefName = this.getFirstNameAndLastName(this.reference.name);
      axios
        .patch(`/api/references/${this.reference.id}/`, {
          ...this.reference,
          user: this.user.id
        })
        .then(res => {
          this.hideModal();
          this.$emit("saved");
        })
        .catch(error => {
          console.log(error);
        });
    },
    showDeleteReferenceConfirmDialog() {
      this.showConfirmDialog({
        ...this.$store.getters.deleteReferenceConfirmDialog,
        onAcceptCallback: this.deleteReference
      });
    },
    deleteReference() {
      if (this.isSendRequest) {
        axios
          .delete(`/api/references/${this.reference.id}/`)
          .then(res => {
            this.hideModal();
            this.$emit("saved");
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.hideModal();
        this.$emit("saved", ACTION_TYPE.DELETE);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          console.log("show?");
          this.submitClicked = false;
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/candidates/dialogs/ReferenceFormDialog.vue